<div class="container">
  <div>
    <img src="../../../assets/images/self-main.png" alt="">
    <h3 class="desc_1">{{'SelfServicePage.MainDescription'|translate}}</h3>
    <h5 class="desc_2">{{'SelfServicePage.MainParagraph'|translate}}</h5>
    <button (click)="redirectToDataStoreList()" mat-raised-button class="custom-primary-button button-md w-100 mt-10">
      <span>{{'SelfServicePage.StartButton'|translate}}</span>
    </button>
  </div>
</div>